var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSmall = function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 57,
    height: 31,
    "data-token-category": "Logos",
    "data-token-description": "Client Logo",
    "data-token-name": "Small Logo",
    viewBox: "0 0 57.5 37.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.207 9.944c-2.3 0-4.2.8-5.9 2.5-1.6 1.7-2.5 3.7-2.5 6.1s.8 4.5 2.5 6.1c1.6 1.7 3.6 2.5 5.9 2.5 1.1 0 2.1-.1 3.1-.4s1.7-.6 2.2-.8l.6-.4 4.1 8.4c-.3.2-.8.5-1.3.9-.6.3-1.9.8-3.9 1.4s-4.2.9-6.5.9c-5.1 0-9.7-1.8-13.6-5.4s-5.8-8-5.8-13c0-5.1 1.9-9.5 5.8-13.1 3.9-3.7 8.4-5.5 13.6-5.5 2.3 0 4.5.3 6.4.8s3.3 1.1 4.2 1.6l1.2.8-4.1 8.3c-1.7-1.2-3.6-1.7-6-1.7m28.388 11.5c2.2 0 4 .8 5.6 2.3 1.5 1.5 2.3 3.4 2.3 5.6 0 2.1-.8 4-2.3 5.5s-3.4 2.3-5.6 2.3c-2.1 0-4-.8-5.5-2.3s-2.3-3.4-2.3-5.5c0-2.2.8-4 2.3-5.6 1.6-1.5 3.4-2.3 5.5-2.3"
  })));
};
export default SvgLogoSmall;